module.exports = __webpack_public_path__ + "img/BofeiHan.23f68d48.jpg";